<div class="card-body center">
    <img src="../../../assets/images/no-data.jpg" alt="no-data">
    <h4 style="text-align: center;">Все още няма данни, моля <a [routerLink]="['transaction']"
            [queryParams]="{ page: 'Add' }">добавете трансакция!</a>
    </h4>
</div>